import React from 'react'
import { isEmpty } from 'lodash'

import { FormField } from '@/components/forms/FormField'
import { TextArea } from '@/components/forms/TextArea'
import { ErrorMessage } from '@/components/forms/ErrorMessage'

export const ToolConfigJsonEditor = ({ value, onChange, error }) => {
  const messages = isEmpty(error) ? [] : error.split('\n')

  return (
    <FormField label="Config" error={!isEmpty(messages)} className="tool-config-json">
      <div className="form-caption">
        The whole config as the API stores it. Groups and each field&apos;s group can only be set
        here.
      </div>
      <TextArea
        rows={30}
        value={value}
        error={!isEmpty(messages)}
        aria-label="Config JSON"
        spellCheck={false}
        onChange={(event) => onChange(event.target.value)}
        data-testid="tool-config-json"
      />
      {messages.map((message) => (
        <ErrorMessage key={message} content={message} />
      ))}
    </FormField>
  )
}
